import DOMPurify from 'dompurify';

const IFRAME_OK = /^https:\/\/(www\.)?(docs\.google\.com|drive\.google\.com|youtube\.com|youtube-nocookie\.com|player\.vimeo\.com|view\.genially\.com|genial\.ly|onedrive\.live\.com|canva\.com|www\.canva\.com)\//i;

DOMPurify.addHook('uponSanitizeElement', (node, data) => {
  if (data.tagName === 'iframe' && !IFRAME_OK.test(node.getAttribute('src') || '')) node.remove();
});

// HTML saisi par les formateurs (cours FOAD, charte) : supprime scripts et gestionnaires d'événements
export const nettoyerHtml = (html) => DOMPurify.sanitize(html || '', {
  ADD_TAGS: ['iframe'],
  ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'target', 'scrolling'],
});
